/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suggestions_Existing_ContentInputs */



/**
* | output |
* | --- |
* | "Existing content at this position" |
*
* @param {Suggestions_Existing_ContentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const suggestions_existing_content = /** @type {((inputs?: Suggestions_Existing_ContentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suggestions_Existing_ContentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestehender Inhalt an dieser Stelle")
	return /** @type {LocalizedString} */ ("Existing content at this position")
});